"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }// src/markdown-renderer/index.ts
var _markdownit = require('markdown-it'); var _markdownit2 = _interopRequireDefault(_markdownit);
function factoryRenderer(set = []) {
  const md = new (0, _markdownit2.default)("zero").enable(set);
  const defaultRender = md.renderer.rules.link_open || function(tokens, idx, options, _env, self) {
    return self.renderToken(tokens, idx, options);
  };
  md.renderer.rules.code_inline = function(tokens, idx, _options, _env, slf) {
    const token = tokens[idx];
    return `<mark${slf.renderAttrs(token)}>${md.utils.escapeHtml(tokens[idx].content)}</mark>`;
  };
  md.renderer.rules.link_open = function(tokens, idx, options, env, self) {
    const aIndex = tokens[idx].attrIndex("target");
    if (aIndex < 0) {
      tokens[idx].attrPush(["target", "_blank"]);
    } else {
      tokens[idx].attrs[aIndex][1] = "_blank";
    }
    return defaultRender(tokens, idx, options, env, self);
  };
  return function(what) {
    return `<div class="markdown">${md.render(what)}</div>`;
  };
}
function tokenToString(token) {
  if (!token.children) {
    return token.content;
  }
  return ` ${token.children.map((child) => {
    switch (child.type) {
      case "code_inline":
      case "text": {
        return child.content;
      }
      case "image": {
        return child.content || "[\u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435]";
      }
      default: {
        return null;
      }
    }
  }).join("")}`;
}
function Cleaner(set = []) {
  const md = new (0, _markdownit2.default)("zero").enable(set);
  return (what) => md.parse(what, {}).map(tokenToString).join("").trim();
}
function ImageExtractor(set = []) {
  const md = new (0, _markdownit2.default)("zero").enable(set);
  return function(markdownInput) {
    const tokens = [...md.parse(String(markdownInput), {})];
    const extractedData = tokens.reduce(
      (accumData, token) => {
        if (!token.children) {
          return accumData;
        }
        const text = token.children.reduce((accumString, child) => {
          switch (child.type) {
            case "text": {
              return `${accumString} ${child.content}`;
            }
            case "image": {
              const image = child.attrs.reduce(
                (acc, curr) => {
                  acc[curr[0]] = curr[1];
                  return acc;
                },
                { alt: "", src: "" }
              );
              accumData.images.push(image);
              return `${accumString} `;
            }
            default: {
              return accumString;
            }
          }
        }, " ");
        accumData.text += text;
        return accumData;
      },
      {
        text: "",
        images: []
      }
    );
    extractedData.text = extractedData.text.trim();
    return extractedData;
  };
}





exports.factoryRenderer = factoryRenderer; exports.Cleaner = Cleaner; exports.ImageExtractor = ImageExtractor;
//# sourceMappingURL=chunk-JAGCZ3IF.js.map